(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-image-disclaimer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-image-disclaimer')) {
    customElements.define(
      'product-image-disclaimer',
      class ProductImageDisclaimer extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';

          const toggle = this.querySelector('.product-image-disclaimer__toggle');
          if (!toggle) return;

          const moreLabel = toggle.dataset.labelMore;
          const lessLabel = toggle.dataset.labelLess;

          this.classList.add('is-collapsed');
          toggle.hidden = false;
          toggle.setAttribute('aria-expanded', 'false');

          toggle.addEventListener('click', () => {
            const isCollapsed = this.classList.toggle('is-collapsed');
            toggle.setAttribute('aria-expanded', isCollapsed ? 'false' : 'true');
            toggle.textContent = isCollapsed ? moreLabel : lessLabel;
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
